// @TODO Remove this helper after refactor ProductCard's prop baseRoute
const getShopCategoryByRoute = (baseRoute: string, routes: {[key: string]: string}): string | void => {
    if (baseRoute in routes) {
        return routes[baseRoute];
    }
};

export default getShopCategoryByRoute;
